<template>
  <v-app>
    <v-main>
      <router-view />
    </v-main>

    <v-snackbar v-model="toast.show" :color="toast.color" :timeout="toast.timeout" location="right bottom">
      {{ toast.message }}

      <template #actions>
        <v-btn icon @click="toast.show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script setup>
import { useToastStore } from '@/stores/toast';
import { storeToRefs } from 'pinia';

const toast = useToastStore()
</script>
